import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
const SolutionsUnitLabel = ({ className }) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("div", { className, "data-t": "product-detail-unit-info" }, getLabel("products.perBottle"));
};
export {
  SolutionsUnitLabel
};
//# sourceMappingURL=SolutionsUnitLabel.js.map
